import Vue from 'vue'
import VueRouter, { RouteConfig, RouterOptions } from 'vue-router'
import routes from './routes.ts'

Vue.use(VueRouter)

let basePath = document.querySelector('meta[name="base-path"]')?.getAttribute('content') || '/'
// eslint-disable-next-line no-template-curly-in-string
basePath = basePath === '${SERVER_URL}' ? '/' : basePath

const router = new VueRouter({
  mode: 'history',
  base: basePath,
  routes,
  scrollBehavior: () => ({ y: 0 }),
  linkActiveClass: 'is-active',
} as RouterOptions)

export default router